(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aromatherapy-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aromatherapy-atc')) {
  class AromatherapyAtc extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.closest('.ah-atc-btn')) this.handleAdd();
      });
    }

    handleAdd() {
      const btn = this.querySelector('.ah-atc-btn');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const btnText = btn.querySelector('.ah-btn-text');
      const spinner = btn.querySelector('.ah-spinner');
      const arr = btn.querySelector('.ah-btn-arr');
      const addText = this.dataset.addText || 'Add to Cart';

      btn.setAttribute('aria-disabled', 'true');
      if (btnText) btnText.textContent = this.dataset.loadingText || 'Adding...';
      if (arr) arr.style.display = 'none';
      if (spinner) spinner.classList.remove('hidden');

      const fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', '1');
      fd.append('sections', 'cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: fd,
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            if (btnText) btnText.textContent = addText;
            btn.removeAttribute('aria-disabled');
            if (arr) arr.style.display = '';
          } else {
            if (btnText) btnText.textContent = this.dataset.addedText || 'Added!';
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble && response.sections && response.sections['cart-icon-bubble']) {
              bubble.innerHTML = new DOMParser()
                .parseFromString(response.sections['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section').innerHTML;
            }
            setTimeout(() => {
              if (btnText) btnText.textContent = addText;
              btn.removeAttribute('aria-disabled');
              if (arr) arr.style.display = '';
            }, 2000);
          }
        })
        .catch(() => {
          if (btnText) btnText.textContent = addText;
          btn.removeAttribute('aria-disabled');
          if (arr) arr.style.display = '';
        })
        .finally(() => {
          if (spinner) spinner.classList.add('hidden');
        });
    }
  }
  customElements.define('aromatherapy-atc', AromatherapyAtc);
}

(function () {
  var rvEls = document.querySelectorAll('.aromatherapy-hero .ah-rv');
  if (!rvEls.length) return;
  if (!('IntersectionObserver' in window)) {
    rvEls.forEach(function (el) { el.classList.add('ah-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('ah-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  rvEls.forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    

$(function () {
  $(".faqs .ans").css("display", "none");
  $(".faqs .qus").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-sticky-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var navEls = document.querySelectorAll(".psn");
  navEls.forEach(function (nav) {
    var links = Array.from(nav.querySelectorAll(".psn__link"));
    var rafId = null;
    var isManualScroll = false;
    var manualScrollTimer = null;

    // Cached layout state — updated only on resize/init, not every scroll frame
    var hdrEl = null;
    var scrollThreshold = 0;
    var lastTopPx = -1;
    var lastVisible = null;

    function findHeader() {
      return (
        document.querySelector("#shopify-section-header") ||
        document.querySelector('[id^="shopify-section-group-header"]') ||
        document.querySelector("sticky-header") ||
        document.querySelector(".site-header")
      );
    }

    function recalcLayout() {
      hdrEl = findHeader();
      // Recalculate threshold once — 2% of total page height in px
      scrollThreshold = document.documentElement.scrollHeight * 0.02;
    }

    function update() {
      rafId = null;
      var scrolled = window.scrollY;

      // Header bottom: read getBCR per frame only because promo/announcement bars
      // collapse on scroll, changing the sticky header's viewport position.
      // Guard against redundant style writes using lastTopPx.
      if (hdrEl) {
        var bottom = Math.max(0, hdrEl.getBoundingClientRect().bottom);
        var bottomRounded = Math.round(bottom);
        if (bottomRounded !== lastTopPx) {
          nav.style.top = bottom + "px";
          lastTopPx = bottomRounded;
        }
      }

      // Visibility toggle — classList only touched when state actually changes
      var visible = scrolled > 0 && scrolled >= scrollThreshold;
      if (visible !== lastVisible) {
        nav.classList.toggle("psn--visible", visible);
        lastVisible = visible;
      }
    }

    function handleScroll() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    }

    links.forEach(function (link) {
      link.addEventListener("click", function (e) {
        var targetId = link.getAttribute("data-target");
        if (!targetId) return;
        var target = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault();

        links.forEach(function (l) { l.classList.remove("psn__link--active"); });
        link.classList.add("psn__link--active");
        link.scrollIntoView({ block: "nearest", inline: "nearest" });

        isManualScroll = true;
        clearTimeout(manualScrollTimer);
        manualScrollTimer = setTimeout(function () { isManualScroll = false; }, 1000);

        var hdrBottom = hdrEl ? Math.max(0, hdrEl.getBoundingClientRect().bottom) : 0;
        var offset = hdrBottom + nav.offsetHeight;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      });
    });

    if ("IntersectionObserver" in window && links.length > 0) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (isManualScroll) return;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var id = entry.target.id;
              links.forEach(function (l) { l.classList.remove("psn__link--active"); });
              var active = nav.querySelector('[data-target="' + id + '"]');
              if (active) {
                active.classList.add("psn__link--active");
                active.scrollIntoView({ block: "nearest", inline: "nearest" });
              }
            }
          });
        },
        { rootMargin: "-10% 0px -80% 0px", threshold: 0 }
      );

      links.forEach(function (link) {
        var targetId = link.getAttribute("data-target");
        var el = targetId ? document.getElementById(targetId) : null;
        if (el) observer.observe(el);
      });
    }

    recalcLayout();

    // ResizeObserver on header: re-cache when header height changes (e.g. mobile menu open)
    if ("ResizeObserver" in window && hdrEl) {
      new ResizeObserver(recalcLayout).observe(hdrEl);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    // Fallback resize listener for browsers without ResizeObserver
    window.addEventListener("resize", recalcLayout, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
